<template>
    <div>
        <template v-if="showList">
            <marshal-booking-list></marshal-booking-list>
        </template>
        <template v-else-if="isMarshal">
            <marshal-booking-view></marshal-booking-view>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        showList() {
            return this.$can('marshal-booking-list');
        },
        isMarshal() {
            return this.$hasRole('Marshal');
        }
    },
}
</script>